import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { gql } from '@apollo/client';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import Loader from '../../components/Loader';
import usePlaceOrder from '../../hooks/usePlaceOrder';
import { useCartContext } from '../../context/CartContext';
import { useUserContext } from '../../context/UserContext';
import useLoyaltyPoints from '../../hooks/useLoyaltyPoints';
import { GET_CARD } from '../../queries/customer';
import { useReservedOrderId } from '../../hooks/useReserveOrderId';
import googleAnalyticsSend from '../../utils/googleAnalyticsSend';
import { GET_BACKEND_CONFIG } from '../../commonQueries';
import { sendTransactionQuarticon } from '../../hooks/useQuarticonHooks';
import { useQuarticonContext } from '../../context/QuarticonContext';
import {purchaseEvent} from "../../hooks/useAnalytics";

const MONRI_SUCCESS_URL = gql`
  query MonriSuccessUrl($url: String!) {
    valid: monriSuccessUrlValidity(url: $url)
  }
`;

const CheckoutPaymentSuccess = () => {
  const client = useApolloClient();
  const history = useNavigate();

  const { data: urlValidity, loading: validatingUrl } = useQuery(MONRI_SUCCESS_URL, {
    fetchPolicy: 'no-cache',
    ssr: false,
    variables: { url: window.location.href },
  });

  const { cart, loading: cartLoading } = useCartContext();
  const { user, loading: userLoading } = useUserContext();
  const { tracker } = useQuarticonContext();

  const isLoyaltyMember = async () => {
    if (!user) return false;

    const { data } = await client.query({
      query: GET_CARD,
      fetchPolicy: 'no-cache',
    });

    return data && data.historyCustomerLoyaltyCard.success;
  };

  const { placeOrder, ...placeOrderData } = usePlaceOrder();
  const reserveOrderId = useReservedOrderId();
  const { loyaltyPoints, loading: loyaltyPointsLoading } = useLoyaltyPoints();

  const { data: backendConfig } = useQuery(GET_BACKEND_CONFIG);

  const [orderId, setOrderId] = useState();

  const loading = cartLoading || userLoading || validatingUrl || loyaltyPointsLoading || !orderId;

  useEffect(() => {
    reserveOrderId()
        .then(result => {
          setOrderId(result);
        })
        .catch(error => {
        });
  }, []);

  useEffect(() => {
    const placeOrderCallback = async () => {
      const url = new URL(window.location.href);
      const params = Object.fromEntries(url.searchParams.entries());

      const { data: orderData } = await placeOrder({
        additionalData: JSON.stringify(params),
      });
      console.log('CHECKOUT SUCCESS',{
        orderNumber: orderData.placeOrder.order.frontend_id,
        paymentMethod: 'pikpay',
        loyaltyPoints,
        email: cart.email,
        isLoyaltyMember: await isLoyaltyMember(),
        isLoggedIn: !!user,
      })
      history('/checkout/success', {
        orderNumber: orderData.placeOrder.order.frontend_id,
        paymentMethod: 'pikpay',
        loyaltyPoints,
        email: cart.email,
        isLoyaltyMember: await isLoyaltyMember(),
        isLoggedIn: !!user,
      });

      purchaseEvent(cart, orderData.placeOrder.order.order_number, backendConfig);
      sendTransactionQuarticon(cart, tracker);
    };

    if (!loading && urlValidity.valid) {
      placeOrderCallback();
    }
  }, [loading]);

  if ((urlValidity && !urlValidity.valid) || placeOrderData.error) {
    return (
      <div
        style={{
          color: 'red',
          fontSize: '24px',
          fontWeight: 600,
          height: '33vh',
          padding: '16px',
        }}
      >
        <p>
          Došlo je do greške u plaćanju, kontaktirajte nas putem info telefona 011 22 59 211 ili putem kontakt forme.
        </p>
        <p>Broj porudžbine: {orderId}</p>
      </div>
    );
  }

  return <Loader css={{ height: '33vh' }} />;
};

export default CheckoutPaymentSuccess;
